import dayjs from "dayjs";

import { ORDER_TYPES } from "../../constants/orders";
import { formatDateMmDdYyyy } from "../../helpers/dateHelper";
import {
  getFormDirtyValues,
  getObjectDifferences,
} from "../../helpers/diffHelper";

export const getFileName = (data) => {
  const order = data?.orders?.length ? data?.orders[0] : {};
  const customer = order?.customer?.name?.replace(/\s+/g, "_");
  const date = formatDateMmDdYyyy(data?.createdAt)?.replace(/\//g, "");
  const number = data?.id;
  const name = `${customer}_Pslip_${date}_${number}_F`;
  return name;
};

const shipmentMapper = (s) => ({
  quantity: s?.weight,
  units: 2,
  price: Number(s?.price || 0).toFixed(2),
  partsQuantity: s?.quantity,
  partId: s?.partId,
  part: s?.part,
});

export const getDefaultValues = (data, shipment, user) => {
  const nonEditable = {
    id: data?.id,
    poNumber: data?.poNumber,
    location: data?.location,
    overShipping: data?.overShipping,
    createdById: data?.createdById || user?.id,
    type: data?.type || ORDER_TYPES.MATERIALS,
  };

  const items = data?.items || shipment?.items?.map(shipmentMapper);
  const shipmentId = data?.shipmentId || shipment?.id;

  const stationId = items?.find((i) => !!i.stationId)?.stationId;

  const defaultValues = {
    ...nonEditable,
    name: data?.name || shipment?.name,
    terms: data?.terms,
    freight: data?.freight,
    shipVia: data?.shipVia,
    customerId: data?.customerId || shipment?.receiverId,
    shipTo: data?.shipTo || shipment?.shipToId,
    returnCustomerId: data?.returnCustomerId || 517,
    returnTo: data?.returnTo || 950,
    notes: data?.notes || "",
    shipmentId,
    dueDate: data?.dueDate,
    createdAt: data?.createdAt || dayjs().toISOString(),
    stationId,
    items: items?.length
      ? items?.map((li) => ({
          lineItemId: li.id,
          quantity: li?.quantity,
          units: li?.units,
          price: Number(li?.price || 0).toFixed(2),
          partId: li?.partId,
          materialId: li?.materialId,
          notes: li?.notes,
        }))
      : [{}],
  };
  return { nonEditable, defaultValues };
};

export const getUpdateDifferences = ({ dirtyFields, formData }) => {
  const newData = getFormDirtyValues(dirtyFields, formData);
  const addUpdatedItems = newData?.items
    ?.map((item, idx) => ({
      id: formData?.items[idx]?.lineItemId,
      ...item,
    }))
    ?.filter((item) => Object.keys(item)?.length > 1);

  if (newData.items) newData.items = addUpdatedItems;

  return newData;
};

export const getUpdatePayload = (formData) => ({
  terms: formData?.terms,
  customerId: Number(formData?.customerId),
  shipTo: Number(formData?.shipTo),
  returnCustomerId: Number(formData?.returnCustomerId),
  returnTo: Number(formData?.returnTo),
  freight: formData?.freight,
  shipVia: formData?.shipVia,
  dueDate: dayjs(formData.dueDate).isValid()
    ? dayjs(formData.dueDate).toISOString()
    : null,
  shippingCost: Number(formData?.shippingCost || 0),
  taxCost: Number(formData?.taxCost || 0),
  otherCost: Number(formData?.otherCost || 0),
  notes: formData?.notes,
  name: formData?.name,
  createdAt: formData?.createdAt,
  createdById: Number(formData?.createdById),
  stationId: formData?.stationId && Number(formData?.stationId),
  items: formData?.items?.map((li, idx) => ({
    id: li?.lineItemId ? Number(li?.lineItemId) : null,
    order: idx,
    partId: li?.partId && Number(li?.partId),
    materialId: li?.materialId && Number(li?.materialId),
    quantity: Number(li?.quantity),
    units: Number(li?.units),
    price: Number(li?.price || 0),
    notes: li?.notes,
  })),
});
